const getChatMessages = async (chatSessionId) => {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/api/chat/getChatMessages`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-SECRET': process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ chatSessionId }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Error response from backend:", errorText);
      throw new Error('Failed to fetch chat messages');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching chat messages:', error);
    throw error;
  }
};

export default getChatMessages;
